// Host-aware base path for the Clara Live mobile app.
//
// The app is one SPA served on several hosts. On the dedicated app
// domain (app.raisedbeef.com) the mobile app owns the whole domain and
// mounts at the root "/", so its URLs carry no prefix. On every other
// host — markets.raisedbeef.ai, the legacy claralive.raisedbeef.ai,
// localhost, Vercel previews — the app lives under "/clara" alongside
// the Market Intelligence Platform.
//
// Every internal Clara link is built through claraPath() so the same
// component code produces "/sales" on the app host and "/clara/sales"
// everywhere else. Route definitions read CLARA_BASE the same way.

export const CLARA_APP_HOSTS = ["app.raisedbeef.com"];

export function isClaraAppHost(): boolean {
  // Native store builds (the DVAuction, LLC mobile app) have no hostname to
  // detect — the Capacitor flavor sets VITE_DVAUCTION_APP=1 at build time to
  // force the app experience, same pattern as VITE_BARN_APP.
  const built = (import.meta.env?.VITE_DVAUCTION_APP as string | undefined)?.trim();
  if (built && built !== "0" && built !== "false") return true;
  return (
    typeof window !== "undefined" &&
    CLARA_APP_HOSTS.includes(window.location.hostname)
  );
}

// "" on the dedicated app host, "/clara" everywhere else. Evaluated once
// at module load — the hostname never changes within a page session.
export const CLARA_BASE = isClaraAppHost() ? "" : "/clara";

// Build a Clara app path from a base-relative sub-path (with or without
// a leading slash):
//   claraPath()           -> "/"        (app host) | "/clara"        (else)
//   claraPath("/sales")   -> "/sales"   (app host) | "/clara/sales"  (else)
//   claraPath("/barn/x")  -> "/barn/x"  (app host) | "/clara/barn/x" (else)
export function claraPath(sub = ""): string {
  const clean = sub.replace(/^\/+/, "");
  if (!clean) return CLARA_BASE || "/";
  return `${CLARA_BASE}/${clean}`;
}
